export const decodeFA = (url: string | null) => {
  if (!url) return null;
  return `fa-${url.split("/")?.pop()?.split("?")[0]}`;
};
